// export const toUTCIsoString = (timestamp) => {
//   if (!timestamp) return '';
  
//   try {
//     const date = new Date(timestamp);
    
//     if (isNaN(date.getTime())) {
//       return '';
//     }
    
//     return date.toISOString();
//   } catch (error) {
//     console.error('Error converting timestamp to UTC ISO string:', error);
//     return '';
//   }
// };
export const formatDate = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  try {
    // Handle both Unix timestamps and ISO strings
    const date = new Date(dateInput);
    
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }
    
    // Use UTC to avoid timezone issues
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    
    return `${day}.${month}.${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return String(dateInput);
  }
};

// export const convertLocalToUTC = (dateString) => {
//   if (!dateString) return '';
  
//   try {
//     const parts = dateString.split('.');
//     if (parts.length !== 3) {
//       console.error('Invalid date format. Expected DD.MM.YYYY but got:', dateString);
//       return '';
//     }
    
//     const [day, month, year] = parts;
    
//     // Create UTC date (noon to avoid timezone issues)
//     const date = new Date(Date.UTC(
//       parseInt(year, 10),
//       parseInt(month, 10) - 1,
//       parseInt(day, 10),
//       12, 0, 0
//     ));
    
//     if (isNaN(date.getTime())) {
//       return '';
//     }
    
//     return date.toISOString();
//   } catch(error) {
//     console.error('Error converting local date to UTC:', error);
//     return '';
//   }
// };

export const convertDateForApi = (isoString) => {
  if (!isoString) return '';
  
  try {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      return '';
    }
    
    return isoString.split('T')[0];
  } catch(error) {
    console.error('Error converting UTC date for API:', error);
    return '';
  }
};

// export const getTodayUTC = () => {
//   return new Date().toISOString();
// };

export const isDateExpired = (dateInput) => {
  if (!dateInput) return false;
  
  try {
    const inputDate = new Date(dateInput);
    if (isNaN(inputDate.getTime())) {
      return false;
    }
    
    const currentDate = new Date();
    
    // Normalize both dates to start of day in UTC for accurate comparison
    const inputUTC = new Date(Date.UTC(
      inputDate.getUTCFullYear(),
      inputDate.getUTCMonth(),
      inputDate.getUTCDate(),
      0, 0, 0, 0
    ));
    
    const currentUTC = new Date(Date.UTC(
      currentDate.getUTCFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getUTCDate(),
      0, 0, 0, 0
    ));
    
    // A date is expired if it's before today (not equal to today)
    return inputUTC.getTime() < currentUTC.getTime();
  } catch (error) {
    console.error('Error checking if date is expired:', error);
    return false;
  }
};

// export const parseInputToUTC = (inputDate) => {
//   if (!inputDate) return '';
  
//   try {
//     // Append time component for consistent UTC conversion
//     const date = new Date(`${inputDate}T12:00:00Z`);
//     if (isNaN(date.getTime())) {
//       return '';
//     }
    
//     return date.toISOString();
//   } catch (error) {
//     console.error('Error parsing input to UTC:', error);
//     return '';
//   }
// };

// export const formatDateForInput = (isoString) => {
//   if (!isoString) return '';
  
//   try {
//     return isoString.split('T')[0];
//   } catch (error) {
//     console.error('Error formatting date for input:', error);
//     return '';
//   }
// };

export const getDateStatus = (expirationDate) => {
  if (!expirationDate) {
    return { isExpired: false, badgeText: '', badgeClass: '' };
  }
  
  const isExpired = isDateExpired(expirationDate);
  
  return {
    isExpired,
    badgeText: isExpired ? 'Abgelaufen' : '',
    badgeClass: isExpired ? 'bg-danger' : ''
  };
};

export const calculateGuaranteeDuration = (issueDate, expirationDate) => {
  if (!issueDate || !expirationDate) return null;
  
  try {
    const start = new Date(issueDate);
    const end = new Date(expirationDate);
    
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return null;
    }
    
    // Calculate the difference in days
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    // Map to standard durations (365 or 730 days)
    if (diffDays <= 365) {
      return 365;
    } else if (diffDays <= 730) {
      return 730;
    }
    
    // Return the actual duration if it's not a standard one
    return diffDays;
  } catch (error) {
    console.error('Error calculating guarantee duration:', error);
    return null;
  }
};
